// extracted by mini-css-extract-plugin
export var showMoreIcon = "styles-module--showMore-icon--1f921";
export var showMoreText = "styles-module--showMore-text--076eb";
export var showMoreWrapper = "styles-module--showMore-wrapper--e41f2";
export var suptitle = "styles-module--suptitle--b0078";